import { Component, Input } from '@angular/core';
import { MenuItemModel } from '../../utilidades.modelos.index';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html'
})
export class MenuComponent {

	@Input("Items") Items: MenuItemModel[];

	constructor() { }
}